// use lodash! https://lodash.com/docs/4.17.15
import filter from "./components/filter";
import advancedFilter from "./components/advancedFilter";
import accordion from "./components/accordion";
import locationSlider from "./components/locationSlider";
import general from "./components/general";
import slideout from "./components/slideout";
import clickableContainer from "./helpers/clickableContainer";
import megaMenu from "./components/megaMenu";
import { programChildHighlight } from "./helpers/programChildHighlight";

const fndryThemeInitWrapper = () => {
    filter();
    advancedFilter();
    accordion();
    locationSlider();
    general();
    slideout();
    clickableContainer();
    megaMenu();
    programChildHighlight();
};

window.fndryThemeInitWrapper = fndryThemeInitWrapper;

// eslint-disable-next-line no-unused-expressions
document.body ? fndryThemeInitWrapper() : document.addEventListener( 'DOMContentLoaded', fndryThemeInitWrapper, false );
